// Here you define your feature's fragments
import { gql } from "@apollo/client";

const Fragments = {
  description: gql`
    fragment description on Description {
      id
      shortDescription
      text
    }
  `
};

export default Fragments;
